import { RouterProvider } from "easy-page-router";

import Router from "./Router";

export default function App() {
  return (
    <RouterProvider>
      <Router />
    </RouterProvider>
  );
}
